import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';
import { atom, useAtomValue } from 'jotai';
import { useMemo } from 'react';

export interface ISEOUrlBuilderOptions {
  /**
   * @default false
   *
   * return a full url rather than path or href
   */
  fullUrl?: boolean;
}

export type SEOUrlBuilder = (pathAndSearch: string, options?: ISEOUrlBuilderOptions) => string;
export type SEOUrlBuilderWithoutOptions = (pathAndSearch: string) => string;

const $SEOLinkBuilder = atom<SEOUrlBuilder>((get) => {
  const { enterHref } = get($RootTraffic);
  const { region } = get($Locale);
  const enterHrefObj = new URL(enterHref);

  return (path: string, options: ISEOUrlBuilderOptions = {}): string => {
    try {
      const { fullUrl } = options;
      const url = new URL(path, enterHrefObj);

      if (!url.searchParams.has('region')) {
        url.searchParams.set('region', region);
      }

      if (fullUrl) {
        return `${url.protocol}//${url.host}${url.pathname}${url.search}`;
      } else {
        return `${url.pathname}${url.search}`;
      }
    } catch (e) {
      return '';
    }
  };
});

export const useSEOLinkBuilder = (): SEOUrlBuilder => useAtomValue($SEOLinkBuilder);

export const useSEOHref: SEOUrlBuilderWithoutOptions = (pathAndSearch: string) => {
  const buildSEOLink = useSEOLinkBuilder();

  return useMemo(() => {
    return buildSEOLink(pathAndSearch);
  }, [buildSEOLink, pathAndSearch]);
};
